<template>
  <div class="image-modal">
    <div class="close" @click="close">
      <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.35742 1.46448L29.6417 29.7487" stroke="white" stroke-width="3"/>
        <path d="M29.6416 1.46448L1.35733 29.7487" stroke="white" stroke-width="3"/>
      </svg>
    </div>
 <div class="image-container">

   <div class="images">
     <div v-for="(image, index) in props.images" class="image-wrapper" :class="{'visible': selectedImage == index}">
       <div class="image">
         <img  :src="image.src"  :alt="image.alt" :key="index" >
       </div>
       <p  class="caption" v-if="image.alt" v-html="image.alt"></p>
     </div>
   </div>
   <div class="image-controls">
     <svg @click="previous" width="42" height="23" viewBox="0 0 42 23" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M0.93934 10.6095C0.353553 11.1953 0.353553 12.145 0.93934 12.7308L10.4853 22.2768C11.0711 22.8626 12.0208 22.8626 12.6066 22.2768C13.1924 21.691 13.1924 20.7412 12.6066 20.1554L4.12132 11.6702L12.6066 3.18488C13.1924 2.5991 13.1924 1.64935 12.6066 1.06356C12.0208 0.477776 11.0711 0.477775 10.4853 1.06356L0.93934 10.6095ZM42 10.1702L2 10.1702L2 13.1702L42 13.1702L42 10.1702Z" fill="white"/>
     </svg>
     <svg @click="next" width="42" height="23" viewBox="0 0 42 23" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M41.0607 12.7308C41.6464 12.145 41.6464 11.1953 41.0607 10.6095L31.5147 1.06356C30.9289 0.477777 29.9792 0.477777 29.3934 1.06356C28.8076 1.64935 28.8076 2.5991 29.3934 3.18489L37.8787 11.6702L29.3934 20.1554C28.8076 20.7412 28.8076 21.691 29.3934 22.2768C29.9792 22.8626 30.9289 22.8626 31.5147 22.2768L41.0607 12.7308ZM0 13.1702H40V10.1702H0V13.1702Z" fill="white"/>
     </svg>
   </div>
 </div>

 </div>
</template>
<script setup lang="ts">
import {computed, ref} from 'vue';

const props = defineProps({
  images: Array,
});

const selectedImage = ref(0);

const activeImage = computed(() => {
  return props.images[selectedImage.value];
})

const emit = defineEmits(['close']);

function close() {
  emit('close');
}

function next() {
  if(selectedImage.value < props.images.length - 1) {
    selectedImage.value++;
  }
  else {
    selectedImage.value = 0;
  }
}

function previous() {
  if(selectedImage.value > 0) {
    selectedImage.value--;
  }
  else {
    selectedImage.value = props.images.length - 1;
  }
}

document.addEventListener("keydown",(e) => {

  if (e.key =='ArrowRight') {
    next();
  }

  if (e.key =='ArrowLeft') {
    previous();
  }
})




</script>
